export default __webpack_public_path__ + "e5c54d152900c45e10391e389ed52148.svg";